// Every Stats view lives in the URL, so a reload or a shared link opens the same range, filter
// and page. A malformed value falls back to the default rather than failing the page.
// [[spec-paginated-opportunity-log-and-trail-with-url-state-collapsible-overview-cards-and-thresholds-on-settings]]
import { z } from "zod";

export const RANGES = [7, 14, 30] as const;
export const DEFAULT_RANGE = 14;

export type LogFilter = "actionable" | "all";

const page = z.number().int().positive().optional().catch(undefined);

export const rangeSearch = z.object({
    days: z
        .number()
        .refine((days) => (RANGES as readonly number[]).includes(days))
        .optional()
        .catch(undefined),
});

export const logSearch = z.object({
    filter: z.enum(["actionable", "all"]).optional().catch(undefined),
    page,
});

/** A detail page's own list, e.g. a window's event trail. */
export const pageSearch = z.object({ page });

export const pairSearch = rangeSearch.extend({
    ...logSearch.shape,
    view: z.enum(["overview", "log"]).optional().catch(undefined),
});
